import { useState, useEffect, useCallback } from 'react';
import { fetchNpsOpenCount } from './npsApi';

const POLL_MS = 5 * 60 * 1000;

export function useNpsOpenCount(enabled) {
  const [count, setCount] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const open = await fetchNpsOpenCount();
      if (open !== null) setCount(open);
    } catch {
      // ignore transient errors
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(null);
      return undefined;
    }

    refresh();

    const intervalId = setInterval(refresh, POLL_MS);

    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    const onCountUpdate = (event) => {
      const open = event?.detail?.open;
      if (typeof open === 'number') setCount(open);
    };

    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', refresh);
    window.addEventListener('nps-open-count', onCountUpdate);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('nps-open-count', onCountUpdate);
    };
  }, [enabled, refresh]);

  return count;
}
